import { render } from "./BasePanelPill.vue?vue&type=template&id=b45e348c"
import script from "./BasePanelPill.vue?vue&type=script&lang=js"
export * from "./BasePanelPill.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__